import { useFormContext } from "react-hook-form";
import {useEffect} from "react";

/**
 * Sets a preset value for a form field if it's not already set
 *
 * @param fieldName The name of the form field.
 * @param presetValue The preset value to set.
 */
export const useSetPresetValue = <T,>(
    fieldName: string,
    presetValue: T | undefined
) => {
    const { getValues, setValue } = useFormContext();
    const currentValue = getValues(fieldName);

    useEffect(() => {
        if (presetValue !== undefined && currentValue !== presetValue) {
            setValue(fieldName, presetValue);
        }
    }, [presetValue, currentValue, setValue, fieldName]);
};
